const holyDays2019 = new Map([
  [
    1,
    [{ date: "2019-01-01", ods: "holy" }, { date: "2019-01-07", ods: "holy" }]
  ],
  [2, []],
  [3, [{ date: "2019-03-25", ods: "holy" }]],
  [
    4,
    [{ date: "2019-04-18", ods: "holy" }, { date: "2019-04-19", ods: "holy" }]
  ],
  [5, [{ date: "2019-05-01", ods: "holy" }]],
  [
    6,
    [{ date: "2019-06-03", ods: "holy" }, { date: "2019-06-24", ods: "holy" }]
  ],
  [
    7,
    [{ date: "2019-07-01", ods: "holy" }, { date: "2019-07-20", ods: "holy" }]
  ],
  [
    8,
    [{ date: "2019-08-07", ods: "holy" }, { date: "2019-08-19", ods: "holy" }]
  ],
  [9, []],
  [10, [{ date: "2019-10-14", ods: "holy" }]],
  [
    11,
    [{ date: "2019-11-04", ods: "holy" }, { date: "2019-11-11", ods: "holy" }]
  ],
  [
    12,
    [{ date: "2019-12-08", ods: "holy" }, { date: "2019-12-25", ods: "holy" }]
  ]
]);

const holyDays2020 = new Map([
  [
    1,
    [{ date: "2020-01-01", ods: "holy" }, { date: "2020-01-06", ods: "holy" }]
  ],
  [2, []],
  [3, [{ date: "2020-03-23", ods: "holy" }]],
  [
    4,
    [{ date: "2020-04-09", ods: "holy" }, { date: "2020-04-10", ods: "holy" }]
  ],
  [
    5,
    [{ date: "2020-05-01", ods: "holy" }, { date: "2020-05-25", ods: "holy" }]
  ],
  [
    6,
    [
      { date: "2020-06-15", ods: "holy" },
      { date: "2020-06-22", ods: "holy" },
      { date: "2020-06-29", ods: "holy" }
    ]
  ],
  [7, [{ date: "2020-07-20", ods: "holy" }]],
  [
    8,
    [{ date: "2020-08-07", ods: "holy" }, { date: "2020-08-17", ods: "holy" }]
  ],
  [9, []],
  [10, [{ date: "2020-10-12", ods: "holy" }]],
  [
    11,
    [{ date: "2020-11-02", ods: "holy" }, { date: "2020-11-16", ods: "holy" }]
  ],
  [
    12,
    [{ date: "2020-12-08", ods: "holy" }, { date: "2020-12-25", ods: "holy" }]
  ]
]);

const holyDays2021 = new Map([
  [
    1,
    [{ date: "2021-01-01", ods: "holy" }, { date: "2021-01-11", ods: "holy" }]
  ],
  [2, []],
  [3, [{ date: "2021-03-22", ods: "holy" }]],
  [
    4,
    [{ date: "2021-04-01", ods: "holy" }, { date: "2021-04-02", ods: "holy" }]
  ],
  [
    5,
    [{ date: "2021-05-01", ods: "holy" }, { date: "2021-05-17", ods: "holy" }]
  ],
  [
    6,
    [{ date: "2021-06-07", ods: "holy" }, { date: "2021-06-14", ods: "holy" }]
  ],
  [
    7,
    [{ date: "2021-07-05", ods: "holy" }, { date: "2021-07-20", ods: "holy" }]
  ],
  [
    8,
    [{ date: "2021-08-07", ods: "holy" }, { date: "2021-08-16", ods: "holy" }]
  ],
  [9, []],
  [10, [{ date: "2021-10-18", ods: "holy" }]],
  [
    11,
    [{ date: "2021-11-01", ods: "holy" }, { date: "2021-11-15", ods: "holy" }]
  ],
  [
    12,
    [{ date: "2021-12-08", ods: "holy" }, { date: "2021-12-25", ods: "holy" }]
  ]
]);

const holyDays2022 = new Map([
  [
    1,
    [{ date: "2022-01-01", ods: "holy" }, { date: "2022-01-10", ods: "holy" }]
  ],
  [2, []],
  [3, [{ date: "2022-03-21", ods: "holy" }]],
  [
    4,
    [{ date: "2022-04-14", ods: "holy" }, { date: "2022-04-15", ods: "holy" }]
  ],
  [5, [{ date: "2022-05-30", ods: "holy" }]],
  [
    6,
    [{ date: "2022-06-20", ods: "holy" }, { date: "2022-06-27", ods: "holy" }]
  ],
  [
    7,
    [{ date: "2022-07-04", ods: "holy" }, { date: "2022-07-20", ods: "holy" }]
  ],
  [
    8,
    [{ date: "2022-08-07", ods: "holy" }, { date: "2022-08-15", ods: "holy" }]
  ],
  [9, []],
  [10, [{ date: "2022-10-17", ods: "holy" }]],
  [
    11,
    [{ date: "2022-11-07", ods: "holy" }, { date: "2022-11-14", ods: "holy" }]
  ],
  [
    12,
    [{ date: "2022-12-08", ods: "holy" }, { date: "2022-12-25", ods: "holy" }]
  ]
]);

const holyDays2023 = new Map([
  [
    1,
    [{ date: "2023-01-01", ods: "holy" }, { date: "2023-01-09", ods: "holy" }]
  ],
  [2, []],
  [3, [{ date: "2023-03-20", ods: "holy" }]],
  [
    4,
    [{ date: "2023-04-06", ods: "holy" }, { date: "2023-04-07", ods: "holy" }]
  ],
  [
    5,
    [{ date: "2023-05-01", ods: "holy" }, { date: "2023-05-22", ods: "holy" }]
  ],
  [
    6,
    [{ date: "2023-06-12", ods: "holy" }, { date: "2023-06-19", ods: "holy" }]
  ],
  [
    7,
    [{ date: "2023-07-03", ods: "holy" }, { date: "2023-07-20", ods: "holy" }]
  ],
  [
    8,
    [{ date: "2023-08-07", ods: "holy" }, { date: "2023-08-21", ods: "holy" }]
  ],
  [9, []],
  [10, [{ date: "2023-10-16", ods: "holy" }]],
  [
    11,
    [{ date: "2023-11-06", ods: "holy" }, { date: "2023-11-13", ods: "holy" }]
  ],
  [
    12,
    [{ date: "2023-12-08", ods: "holy" }, { date: "2023-12-25", ods: "holy" }]
  ]
]);

const holyDays2024 = new Map([
  [
    1,
    [{ date: "2024-01-01", ods: "holy" }, { date: "2024-01-08", ods: "holy" }]
  ],
  [2, []],
  [
    3,
    [
      { date: "2024-03-25", ods: "holy" },
      { date: "2024-03-28", ods: "holy" },
      { date: "2024-03-29", ods: "holy" }
    ]
  ],
  [4, []],
  [
    5,
    [{ date: "2024-05-01", ods: "holy" }, { date: "2024-05-13", ods: "holy" }]
  ],
  [
    6,
    [{ date: "2024-06-03", ods: "holy" }, { date: "2024-06-10", ods: "holy" }]
  ],
  [
    7,
    [{ date: "2024-07-01", ods: "holy" }, { date: "2024-07-20", ods: "holy" }]
  ],
  [
    8,
    [{ date: "2024-08-07", ods: "holy" }, { date: "2024-08-19", ods: "holy" }]
  ],
  [9, []],
  [10, [{ date: "2024-10-14", ods: "holy" }]],
  [
    11,
    [{ date: "2024-11-04", ods: "holy" }, { date: "2024-11-11", ods: "holy" }]
  ],
  [
    12,
    [{ date: "2024-12-08", ods: "holy" }, { date: "2024-12-25", ods: "holy" }]
  ]
]);

const holyDays2025 = new Map([
  [
    1,
    [{ date: "2025-01-01", ods: "holy" }, { date: "2025-01-06", ods: "holy" }]
  ],
  [2, []],
  [3, [{ date: "2025-03-24", ods: "holy" }]],
  [
    4,
    [{ date: "2025-04-17", ods: "holy" }, { date: "2025-04-18", ods: "holy" }]
  ],
  [5, [{ date: "2025-05-01", ods: "holy" }]],
  [
    6,
    [
      { date: "2025-06-02", ods: "holy" },
      { date: "2025-06-23", ods: "holy" },
      { date: "2025-06-30", ods: "holy" }
    ]
  ],
  [7, []],
  [
    8,
    [{ date: "2025-08-07", ods: "holy" }, { date: "2025-08-18", ods: "holy" }]
  ],
  [9, []],
  [10, [{ date: "2025-10-13", ods: "holy" }]],
  [
    11,
    [{ date: "2025-11-03", ods: "holy" }, { date: "2025-11-17", ods: "holy" }]
  ],
  [
    12,
    [{ date: "2025-12-08", ods: "holy" }, { date: "2025-12-25", ods: "holy" }]
  ]
]);

const holyDays2026 = new Map([
  [
    1,
    [{ date: "2026-01-01", ods: "holy" }, { date: "2026-01-12", ods: "holy" }]
  ],
  [2, []],
  [3, [{ date: "2026-03-23", ods: "holy" }]],
  [
    4,
    [{ date: "2026-04-02", ods: "holy" }, { date: "2026-04-03", ods: "holy" }]
  ],
  [
    5,
    [{ date: "2026-05-01", ods: "holy" }, { date: "2026-05-18", ods: "holy" }]
  ],
  [
    6,
    [
      { date: "2026-06-08", ods: "holy" },
      { date: "2026-06-15", ods: "holy" },
      { date: "2026-06-29", ods: "holy" }
    ]
  ],
  [7, [{ date: "2026-07-20", ods: "holy" }]],
  [
    8,
    [{ date: "2026-08-07", ods: "holy" }, { date: "2026-08-17", ods: "holy" }]
  ],
  [9, []],
  [10, [{ date: "2026-10-12", ods: "holy" }]],
  [
    11,
    [{ date: "2026-11-02", ods: "holy" }, { date: "2026-11-16", ods: "holy" }]
  ],
  [
    12,
    [{ date: "2026-12-08", ods: "holy" }, { date: "2026-12-25", ods: "holy" }]
  ]
]);

const holyDaysCO = new Map([
  [2019, holyDays2019],
  [2020, holyDays2020],
  [2021, holyDays2021],
  [2022, holyDays2022],
  [2023, holyDays2023],
  [2024, holyDays2024],
  [2025, holyDays2025],
  [2026, holyDays2026]
]);

export { holyDaysCO };
